import { Input } from "@visiblethread/react-components";
import { func, object, string } from "prop-types";
import { memo } from "react";

import classes from "./DateSearchFilter.module.scss";

const DateSearchFilter = ({ filter, fromKey, label, onChange, toKey }) => {
  const onChangeDate = (targetKey) => (value) => {
    onChange(value, targetKey);
  };

  return (
    <div
      className={classes["date_search_filter"]}
      data-testid="date_search_filter"
    >
      <Input
        className={classes["date_search_filter__input"]}
        data-testid="from_input"
        label={label}
        onChange={onChangeDate(fromKey)}
        prefix="From"
        type="date"
        value={filter[fromKey] || ""}
      />
      <strong>to</strong>
      <Input
        className={classes["date_search_filter__input"]}
        data-testid="to_input"
        label=" "
        onChange={onChangeDate(toKey)}
        prefix="To"
        type="date"
        value={filter[toKey] || ""}
      />
    </div>
  );
};

DateSearchFilter.propTypes = {
  filter: object,
  fromKey: string.isRequired,
  label: string,
  onChange: func,
  toKey: string.isRequired,
};

export default memo(DateSearchFilter);
